import {
  AnalyticsEventType,
  trackEvent,
  unidentifiedEvents,
} from 'utils/analytics';

export async function trackUserEvent(
  merchantId: string | null,
  event: AnalyticsEventType,
  payload: Record<string, unknown> = {},
) {
  if (!merchantId) {
    unidentifiedEvents.push({ type: event, payload });
  } else {
    await trackEvent(event, payload);
  }
}
